var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cb-class", attrs: { id: "chatbot" } },
    [
      _c(
        "AppBreadCrumb",
        { attrs: { paths: [{ title: "ChatBot" }], select: true } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "bottom-end" },
                  expression: "{ followCursor: true, placement: 'bottom-end' }",
                },
              ],
              staticClass: "custom-checkbox2",
              attrs: { content: _vm.$t("message.showChatBot") },
            },
            [
              _c(
                "a-switch",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.chatBotEnabled,
                    callback: function ($$v) {
                      _vm.chatBotEnabled = $$v
                    },
                    expression: "chatBotEnabled",
                  },
                },
                [
                  _c("a-icon", {
                    attrs: { slot: "checkedChildren", type: "check" },
                    slot: "checkedChildren",
                  }),
                  _vm._v(" "),
                  _c("a-icon", {
                    attrs: { slot: "unCheckedChildren", type: "close" },
                    slot: "unCheckedChildren",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("message.chatBot")))]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.isLoaded
        ? _c(
            "b-container",
            { staticClass: "mt-3", attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mx-0" },
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "12" } },
                    [
                      _c(
                        "b-card",
                        { staticClass: "vh100", attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-body",
                            {
                              staticClass:
                                "d-flex align-items-center flex-column overflow-auto pb-5",
                            },
                            [
                              !!!_vm.chatSteps.length
                                ? _c(
                                    "div",
                                    { staticClass: "cb-start" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "cb-button" },
                                        [
                                          _c(
                                            "md-button",
                                            {
                                              staticClass: "text-white",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addStep(
                                                    { key: "content" },
                                                    null,
                                                    false,
                                                    true
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "chatbot.startToDesign"
                                                    )
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("BotDance"),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !!_vm.chatSteps.length
                                ? _c("Step", {
                                    attrs: {
                                      "add-step": _vm.addStep,
                                      path: _vm.path,
                                      select: function (step, buttonClicked) {
                                        _vm.selectedItem = step
                                        if (!buttonClicked) {
                                          _vm.visible = true
                                        }
                                      },
                                      selected: _vm.selectedItem,
                                      sidePanelVisible: _vm.visible,
                                      step: _vm.chatSteps[0],
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-drawer",
                    {
                      staticClass: "chatbotDrawer",
                      attrs: {
                        closable: false,
                        visible: _vm.visible,
                        width: 550,
                        placement: "right",
                      },
                      on: { close: _vm.update },
                    },
                    [
                      _vm.selectedItem
                        ? _c(
                            "b-row",
                            { staticClass: "cb-class h-100" },
                            [
                              _vm.selectedItem.type === "content"
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "px-3",
                                      staticStyle: {
                                        "border-right": "1px solid #eeeeee",
                                      },
                                      attrs: { lg: "2" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                                            },
                                          ],
                                          staticClass:
                                            "mx-0 mb-2 p-0 add-actions-card",
                                          attrs: {
                                            content: _vm.$t("chatbot.text"),
                                          },
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "m-0 p-0 button-content",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addItem("text")
                                                },
                                              },
                                            },
                                            [
                                              _c("md-icon", [_vm._v("add")]),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t("message.addText")
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                                            },
                                          ],
                                          staticClass:
                                            "mx-0 mb-2 p-0 add-actions-card",
                                          attrs: {
                                            content:
                                              _vm.$t("chatbot.randomText"),
                                          },
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "m-0 p-0 button-content",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addItem("random")
                                                },
                                              },
                                            },
                                            [
                                              _c("md-icon", [_vm._v("add")]),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.addRandomText"
                                                    )
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                                            },
                                          ],
                                          staticClass:
                                            "mx-0 mb-2 add-actions-card",
                                          attrs: {
                                            content: _vm.$t("chatbot.image"),
                                          },
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "m-0 p-0 button-content",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addItem("image")
                                                },
                                              },
                                            },
                                            [
                                              _c("md-icon", [_vm._v("add")]),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t("message.addImage")
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                                            },
                                          ],
                                          staticClass:
                                            "mx-0 mb-2 p-0 add-actions-card",
                                          attrs: {
                                            content: _vm.$t("chatbot.ticket"),
                                          },
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "m-0 p-0 button-content",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addItem(
                                                    "ticket",
                                                    true
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("md-icon", [_vm._v("add")]),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t("message.addTicket")
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                                            },
                                          ],
                                          staticClass:
                                            "mx-0 mb-2 p-0 add-actions-card",
                                          attrs: {
                                            content: _vm.$t("chatbot.goto"),
                                          },
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "m-0 p-0 button-content",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addItem("goto")
                                                },
                                              },
                                            },
                                            [
                                              _c("md-icon", [_vm._v("add")]),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t("message.addGOTO")
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                                            },
                                          ],
                                          staticClass:
                                            "mx-0 mb-2 p-0 add-actions-card",
                                          attrs: {
                                            content: _vm.$t("chatbot.link"),
                                          },
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "m-0 p-0 button-content",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addItem("link")
                                                },
                                              },
                                            },
                                            [
                                              _c("md-icon", [_vm._v("add")]),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t("message.addLink")
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mx-0 mb-2 p-0 add-actions-card",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "m-0 p-0 button-content",
                                              staticStyle: { color: "#3aad55" },
                                              on: { click: _vm.update },
                                            },
                                            [
                                              _c(
                                                "md-icon",
                                                {
                                                  staticStyle: {
                                                    color: "#3aad55",
                                                  },
                                                },
                                                [_vm._v("save")]
                                              ),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t("message.update")
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedItem.type === "menu"
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "px-0",
                                      staticStyle: {
                                        "border-right": "1px solid #eeeeee",
                                      },
                                      attrs: { lg: "2" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                                            },
                                          ],
                                          staticClass:
                                            "mx-0 mb-2 p-0 add-actions-card",
                                          attrs: {
                                            content: _vm.$t("chatbot.button"),
                                          },
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "m-0 p-0 button-content",
                                              on: { click: _vm.addButton },
                                            },
                                            [
                                              _c("md-icon", [_vm._v("add")]),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t("message.addButton")
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mx-0 mb-2 p-0 add-actions-card",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "m-0 p-0 button-content",
                                              staticStyle: { color: "#3aad55" },
                                              on: { click: _vm.update },
                                            },
                                            [
                                              _c(
                                                "md-icon",
                                                {
                                                  staticStyle: {
                                                    color: "#3aad55",
                                                  },
                                                },
                                                [_vm._v("save")]
                                              ),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t("message.update")
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedItem.type === "form"
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "px-0",
                                      staticStyle: {
                                        "border-right": "1px solid #eeeeee",
                                      },
                                      attrs: { lg: "2" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                                            },
                                          ],
                                          staticClass:
                                            "mx-0 mb-2 p-0 add-actions-card",
                                          attrs: {
                                            content: _vm.$t("chatbot.question"),
                                          },
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "m-0 p-0 button-content",
                                              on: { click: _vm.addInput },
                                            },
                                            [
                                              _c("md-icon", [_vm._v("add")]),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t("message.addInput")
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mx-0 mb-2 p-0 add-actions-card",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "m-0 p-0 button-content",
                                              staticStyle: { color: "#3aad55" },
                                              on: { click: _vm.update },
                                            },
                                            [
                                              _c(
                                                "md-icon",
                                                {
                                                  staticStyle: {
                                                    color: "#3aad55",
                                                  },
                                                },
                                                [_vm._v("save")]
                                              ),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t("message.update")
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("b-col", { attrs: { lg: "10" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cb-container h-100 position-relative",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "header p-3" },
                                      [
                                        _c(
                                          "md-field",
                                          { staticClass: "bg-transparent m-0" },
                                          [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.stepTitle")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("md-input", {
                                              attrs: { type: "text" },
                                              model: {
                                                value:
                                                  _vm.selectedItem.description,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.selectedItem,
                                                    "description",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedItem.description",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "cb-close-btn top-right-corner",
                                            on: { click: _vm.onDeleteStep },
                                          },
                                          [
                                            _c(
                                              "md-icon",
                                              { staticStyle: { color: "red" } },
                                              [_vm._v("delete")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.selectedItem.type === "menu"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cb-text-checkboxes",
                                              },
                                              [
                                                _c(
                                                  "md-checkbox",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tippy",
                                                        rawName: "v-tippy",
                                                        value: {
                                                          followCursor: true,
                                                          placement:
                                                            "bottom-end",
                                                        },
                                                        expression:
                                                          "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                        }",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "md-primary mb-0",
                                                    attrs: {
                                                      content:
                                                        _vm.$t("chatbot.prev"),
                                                      type: "checkbox",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedItem
                                                          .showPrevMenuButton,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.selectedItem,
                                                          "showPrevMenuButton",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedItem.showPrevMenuButton",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.prevStep"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-checkbox",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tippy",
                                                        rawName: "v-tippy",
                                                        value: {
                                                          followCursor: true,
                                                          placement:
                                                            "bottom-end",
                                                        },
                                                        expression:
                                                          "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                        }",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "md-primary mb-0",
                                                    attrs: {
                                                      content: _vm.$t(
                                                        "chatbot.transferLiveChatOption"
                                                      ),
                                                      type: "checkbox",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedItem
                                                          .showLiveChatButton,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.selectedItem,
                                                          "showLiveChatButton",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedItem.showLiveChatButton",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.goToLive"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.selectedItem.type === "content"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cb-text-checkboxes",
                                              },
                                              [
                                                _vm.selectedItem.nextStepId ===
                                                null
                                                  ? _c(
                                                      "md-checkbox",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "tippy",
                                                            rawName: "v-tippy",
                                                            value: {
                                                              followCursor: true,
                                                              placement:
                                                                "bottom-end",
                                                            },
                                                            expression:
                                                              "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                        }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "md-primary mb-0",
                                                        attrs: {
                                                          content:
                                                            _vm.$t(
                                                              "chatbot.closeChat"
                                                            ),
                                                          type: "checkbox",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.selectedItem
                                                              .closeChat,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.selectedItem,
                                                              "closeChat",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "selectedItem.closeChat",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.closeChat"
                                                              )
                                                            ) +
                                                            "\n                                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.selectedItem.type === "content"
                                      ? _c(
                                          "div",
                                          { staticClass: "aiTagList px-3" },
                                          [
                                            _c("a-divider", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chatbot.keywords")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    (
                                                      _vm.selectedItem.tags ||
                                                      []
                                                    ).length < 15,
                                                  expression:
                                                    "(selectedItem.tags || []).length < 15",
                                                },
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.tag,
                                                  expression: "tag",
                                                },
                                              ],
                                              staticClass:
                                                "w-100 bg-white border-0 px-3 d-block mt-2 stepItem",
                                              staticStyle: { height: "50px" },
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "chatbot.typeKeyword"
                                                ),
                                              },
                                              domProps: { value: _vm.tag },
                                              on: {
                                                keydown: function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.addTag.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.tag = $event.target.value
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.selectedItem.tags,
                                              function (tag, i) {
                                                return _c(
                                                  "md-chip",
                                                  {
                                                    key: i,
                                                    staticClass:
                                                      "md-primary mt-3 user-select-none ml-0 mr-1",
                                                    staticStyle: {
                                                      height: "30px",
                                                    },
                                                    attrs: {
                                                      "md-deletable": "",
                                                    },
                                                    on: {
                                                      "md-delete": function (
                                                        $event
                                                      ) {
                                                        return _vm.selectedItem.tags.splice(
                                                          i,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(tag) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.selectedItem.textItems,
                                      function (textItem, i) {
                                        return _vm.selectedItem.type ===
                                          "content"
                                          ? _c(
                                              "div",
                                              {
                                                key: i,
                                                staticClass:
                                                  "my-1 position-relative px-3 py-2 cb-hover-item cb-container",
                                              },
                                              [
                                                _c(
                                                  "a-divider",
                                                  {
                                                    staticStyle: {
                                                      margin:
                                                        "10px 0 !important",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "chatbot.types." +
                                                              textItem.type
                                                          )
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "cb-hover-close-btn",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.selectedItem.textItems.splice(
                                                          i,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "md-icon",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [_vm._v("delete")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                i !== 0
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "cb-hover-up-btn",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.moveUp(i)
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "md-icon",
                                                          {
                                                            staticClass:
                                                              "text-info",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "arrow_upward"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                i !==
                                                _vm.selectedItem.textItems
                                                  .length -
                                                  1
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "cb-hover-down-btn",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.moveDown(
                                                              i
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "md-icon",
                                                          {
                                                            staticClass:
                                                              "text-info",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "arrow_downward"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                textItem.type !== "goto"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "cb-slider-con",
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "d-flex",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "tippy",
                                                                          rawName:
                                                                            "v-tippy",
                                                                          value:
                                                                            {
                                                                              followCursor: true,
                                                                              placement:
                                                                                "bottom-end",
                                                                            },
                                                                          expression:
                                                                            "{\n                                                    followCursor: true,\n                                                    placement: 'bottom-end',\n                                                }",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "cb-delay-btn d-inline bg-secondary text-white mr-3",
                                                                    attrs: {
                                                                      content:
                                                                        _vm.$t(
                                                                          "chatbot.delay"
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "md-icon",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "14px !important",
                                                                            color:
                                                                              "white",
                                                                            height:
                                                                              "100% !important",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                    alarm\n                                                "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "chatbot.snDelay",
                                                                            {
                                                                              delay:
                                                                                textItem.delay,
                                                                            }
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  staticClass:
                                                                    "cb-check-btn",
                                                                  attrs: {
                                                                    type: "checkbox",
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        textItem.delay,
                                                                      expression:
                                                                        "textItem.delay",
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "cb-text-range",
                                                                  attrs: {
                                                                    max: "10",
                                                                    min: "0",
                                                                    type: "range",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      textItem.delay,
                                                                  },
                                                                  on: {
                                                                    __r: function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$set(
                                                                        textItem,
                                                                        "delay",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "md-checkbox",
                                                          {
                                                            staticClass:
                                                              "md-primary m-0",
                                                            staticStyle: {
                                                              "margin-top":
                                                                "-7px !important",
                                                            },
                                                            attrs: {
                                                              type: "checkbox",
                                                            },
                                                            model: {
                                                              value:
                                                                textItem.visible,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    textItem,
                                                                    "visible",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "textItem.visible",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                        " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "message.active"
                                                                  )
                                                                ) +
                                                                "\n                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                textItem.type === "text"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cb-text-item",
                                                      },
                                                      [
                                                        _c(
                                                          "Mentionable",
                                                          {
                                                            attrs: {
                                                              items:
                                                                _vm.mentions,
                                                              keys: ["@"],
                                                              offset: "6",
                                                            },
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    textItem.message,
                                                                  expression:
                                                                    "textItem.message",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "w-100 bg-white border-0 px-3 d-block mt-2 stepItem",
                                                              staticStyle: {
                                                                height: "50px",
                                                                "border-radius":
                                                                  "16px",
                                                              },
                                                              attrs: {
                                                                placeholder:
                                                                  _vm.$t(
                                                                    "chatbot.contentTitle"
                                                                  ),
                                                                type: "text",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  textItem.message,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      textItem,
                                                                      "message",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                textItem.type === "link"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cb-text-item",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                textItem
                                                                  .message[0],
                                                              expression:
                                                                "textItem.message[0]",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "w-100 bg-white border-0 px-3 d-block mt-2 stepItem",
                                                          staticStyle: {
                                                            height: "50px",
                                                            "border-radius":
                                                              "16px",
                                                            "text-decoration":
                                                              "underline",
                                                          },
                                                          attrs: {
                                                            placeholder:
                                                              _vm.$t(
                                                                "chatbot.linkTitle"
                                                              ),
                                                            type: "text",
                                                          },
                                                          domProps: {
                                                            value:
                                                              textItem
                                                                .message[0],
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                textItem.message,
                                                                0,
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                textItem
                                                                  .message[1],
                                                              expression:
                                                                "textItem.message[1]",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "w-100 bg-white border-0 px-3 d-block mt-2 stepItem",
                                                          staticStyle: {
                                                            height: "50px",
                                                            "border-radius":
                                                              "16px",
                                                          },
                                                          attrs: {
                                                            placeholder: _vm.$t(
                                                              "chatbot.linkAddress"
                                                            ),
                                                            type: "text",
                                                          },
                                                          domProps: {
                                                            value:
                                                              textItem
                                                                .message[1],
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                textItem.message,
                                                                1,
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                textItem.type === "goto"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cb-text-item",
                                                      },
                                                      [
                                                        _c("multiselect", {
                                                          staticClass:
                                                            "stepItem",
                                                          attrs: {
                                                            label:
                                                              "description",
                                                            "track-by": "_id",
                                                            options:
                                                              _vm.chatSteps.filter(
                                                                function (x) {
                                                                  return (
                                                                    x._id !==
                                                                    _vm
                                                                      .selectedItem
                                                                      ._id
                                                                  )
                                                                }
                                                              ),
                                                            multiple: false,
                                                            placeholder:
                                                              _vm.$t(
                                                                "message.selectStep"
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              textItem.message,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                textItem,
                                                                "message",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "textItem.message",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                textItem.type === "ticket"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cb-text-item",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                textItem.ticketTopic,
                                                              expression:
                                                                "textItem.ticketTopic",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "w-100 bg-white border-0 px-3 d-block mt-2 stepItem",
                                                          staticStyle: {
                                                            height: "50px",
                                                            "border-radius":
                                                              "16px",
                                                          },
                                                          attrs: {
                                                            placeholder: _vm.$t(
                                                              "chatbot.subjectTitle"
                                                            ),
                                                            type: "text",
                                                          },
                                                          domProps: {
                                                            value:
                                                              textItem.ticketTopic,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                textItem,
                                                                "ticketTopic",
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "Mentionable",
                                                          {
                                                            attrs: {
                                                              items:
                                                                _vm.mentions,
                                                              keys: ["@"],
                                                              offset: "6",
                                                            },
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    textItem.message,
                                                                  expression:
                                                                    "textItem.message",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "w-100 bg-white border-0 px-3 d-block mt-2 stepItem",
                                                              staticStyle: {
                                                                height: "50px",
                                                                "border-radius":
                                                                  "16px",
                                                              },
                                                              attrs: {
                                                                placeholder:
                                                                  _vm.$t(
                                                                    "chatbot.ticketSuccesfull"
                                                                  ),
                                                                type: "text",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  textItem.message,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      textItem,
                                                                      "message",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                textItem.type === "random"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cb-text-item",
                                                      },
                                                      [
                                                        _c(
                                                          "b-tabs",
                                                          {
                                                            staticClass: "mt-2",
                                                            class:
                                                              "textItemforTab-" +
                                                              i,
                                                            attrs: {
                                                              "activate-tab":
                                                                "",
                                                            },
                                                          },
                                                          [
                                                            _vm._l(
                                                              textItem.message,
                                                              function (m, j) {
                                                                return _c(
                                                                  "b-tab",
                                                                  { key: j },
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        staticClass:
                                                                          "bg-danger",
                                                                        slot: "title",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                " +
                                                                            _vm._s(
                                                                              j +
                                                                                1
                                                                            ) +
                                                                            "\n                                            "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    textItem
                                                                      .message
                                                                      .length >
                                                                    2
                                                                      ? _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "btnDeleteRandomMessage",
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.deleteRandomMessage(
                                                                                    i,
                                                                                    j
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "md-icon",
                                                                              {
                                                                                staticClass:
                                                                                  "text-danger",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "delete"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "Mentionable",
                                                                      {
                                                                        attrs: {
                                                                          items:
                                                                            _vm.mentions,
                                                                          keys: [
                                                                            "@",
                                                                          ],
                                                                          "insert-space":
                                                                            "",
                                                                          offset:
                                                                            "6",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "model",
                                                                                  rawName:
                                                                                    "v-model",
                                                                                  value:
                                                                                    _vm
                                                                                      .selectedItem
                                                                                      .textItems[
                                                                                      i
                                                                                    ]
                                                                                      .message[
                                                                                      j
                                                                                    ],
                                                                                  expression:
                                                                                    "selectedItem.textItems[i].message[j]",
                                                                                },
                                                                              ],
                                                                            staticClass:
                                                                              "w-100 bg-white border-0 px-3 d-block mt-2 stepItem",
                                                                            staticStyle:
                                                                              {
                                                                                height:
                                                                                  "50px",
                                                                              },
                                                                            attrs:
                                                                              {
                                                                                placeholder:
                                                                                  _vm.$t(
                                                                                    "chatbot.randomTextPlaceHolder"
                                                                                  ),
                                                                                type: "text",
                                                                              },
                                                                            domProps:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .selectedItem
                                                                                    .textItems[
                                                                                    i
                                                                                  ]
                                                                                    .message[
                                                                                    j
                                                                                  ],
                                                                              },
                                                                            on: {
                                                                              input:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    $event
                                                                                      .target
                                                                                      .composing
                                                                                  ) {
                                                                                    return
                                                                                  }
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .selectedItem
                                                                                      .textItems[
                                                                                      i
                                                                                    ]
                                                                                      .message,
                                                                                    j,
                                                                                    $event
                                                                                      .target
                                                                                      .value
                                                                                  )
                                                                                },
                                                                            },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  2
                                                                )
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c("b-tab", {
                                                              key: textItem
                                                                .message.length,
                                                              attrs: {
                                                                title: "+",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.selectedItem.textItems[
                                                                      i
                                                                    ].message.push(
                                                                      ""
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          2
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                textItem.type === "image"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cb-text-item d-flex",
                                                      },
                                                      [
                                                        textItem.asset
                                                          ? _c(
                                                              "div",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "tippy",
                                                                    rawName:
                                                                      "v-tippy",
                                                                    value: {
                                                                      followCursor: true,
                                                                      placement:
                                                                        "bottom-end",
                                                                    },
                                                                    expression:
                                                                      "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                        }",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "cb-img-preview position-relative",
                                                                attrs: {
                                                                  content:
                                                                    _vm.$t(
                                                                      "chatbot.imageView"
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticClass:
                                                                    "img-thumbnail ant-upload-list-picture-card-container",
                                                                  staticStyle: {
                                                                    "object-fit":
                                                                      "cover",
                                                                  },
                                                                  attrs: {
                                                                    src:
                                                                      "http://static.supsis.live/" +
                                                                      textItem
                                                                        .asset
                                                                        .path +
                                                                      textItem
                                                                        .asset
                                                                        ._id,
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "cb-hover ant-upload-list-picture-card-container d-flex align-items-center justify-content-center",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.previewImg =
                                                                            "http://static.supsis.live/" +
                                                                            textItem
                                                                              .asset
                                                                              .path +
                                                                            textItem
                                                                              .asset
                                                                              ._id
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "md-icon",
                                                                      {
                                                                        staticClass:
                                                                          "text-white",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "visibility"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "a-modal",
                                                                  {
                                                                    attrs: {
                                                                      footer:
                                                                        null,
                                                                      visible:
                                                                        !!_vm.previewImg,
                                                                    },
                                                                    on: {
                                                                      cancel:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.previewImg =
                                                                            null
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("img", {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                      attrs: {
                                                                        src: _vm.previewImg,
                                                                      },
                                                                    }),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "label",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "tippy",
                                                                rawName:
                                                                  "v-tippy",
                                                                value: {
                                                                  followCursor: true,
                                                                  placement:
                                                                    "bottom-end",
                                                                },
                                                                expression:
                                                                  "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                        }",
                                                              },
                                                            ],
                                                            attrs: {
                                                              content:
                                                                _vm.$t(
                                                                  "chatbot.upload"
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "ant-upload ant-upload-select-picture-card",
                                                                staticStyle: {
                                                                  width: "50px",
                                                                  height:
                                                                    "50px",
                                                                },
                                                              },
                                                              [
                                                                _c("a-icon", {
                                                                  staticClass:
                                                                    "ant-upload",
                                                                  attrs: {
                                                                    type: textItem.asset
                                                                      ? "edit"
                                                                      : "plus",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              staticClass:
                                                                "d-none",
                                                              attrs: {
                                                                id:
                                                                  "imageItem-" +
                                                                  i,
                                                                type: "file",
                                                              },
                                                              on: {
                                                                change:
                                                                  function (e) {
                                                                    return _vm.uploadFile(
                                                                      e,
                                                                      i
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    _vm._v(" "),
                                    _vm.selectedItem.type === "menu"
                                      ? _c(
                                          "div",
                                          [
                                            _c("a-divider", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chatbot.menuMessage")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cb-text-item px-3",
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.selectedItem
                                                          .textItems[0].message,
                                                      expression:
                                                        "selectedItem.textItems[0].message",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "w-100 bg-white border-0 px-3 d-block mt-2 stepItem",
                                                  staticStyle: {
                                                    height: "50px",
                                                    "border-radius": "16px",
                                                  },
                                                  attrs: {
                                                    placeholder: _vm.$t(
                                                      "chatbot.contentTitle"
                                                    ),
                                                    type: "text",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.selectedItem
                                                        .textItems[0].message,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.selectedItem
                                                          .textItems[0],
                                                        "message",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("a-divider", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chatbot.selection")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.selectedItem.menuItems,
                                              function (menuItem, i) {
                                                return _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "my-2 position-relative px-3 py-1 cb-hover-item cb-container",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "d-flex" },
                                                      [
                                                        _vm.selectedItem
                                                          .menuItems.length > 2
                                                          ? _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "cb-hover-close-btn top-right-corner",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.selectedItem.menuItems.splice(
                                                                        i,
                                                                        1
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "md-icon",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "delete"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        i !== 0
                                                          ? _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "cb-hover-up-btn",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.moveUp(
                                                                        i,
                                                                        "menuItems"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "md-icon",
                                                                  {
                                                                    staticClass:
                                                                      "text-info",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "arrow_upward"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        i !==
                                                        _vm.selectedItem
                                                          .menuItems.length -
                                                          1
                                                          ? _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "cb-hover-down-btn",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.moveDown(
                                                                        i,
                                                                        "menuItems"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "md-icon",
                                                                  {
                                                                    staticClass:
                                                                      "text-info",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "arrow_downward"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cb-text-item cb-menu-button py-3",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                menuItem.title,
                                                              expression:
                                                                "menuItem.title",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "border-0 px-3 d-block mt-2 btn btn-info text-info bg-white",
                                                          staticStyle: {
                                                            height: "50px",
                                                            "border-radius":
                                                              "16px",
                                                            margin: "0 auto",
                                                          },
                                                          attrs: {
                                                            placeholder: _vm.$t(
                                                              "chatbot.buttonTitle"
                                                            ),
                                                            type: "text",
                                                          },
                                                          domProps: {
                                                            value:
                                                              menuItem.title,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                menuItem,
                                                                "title",
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cb-text-item cb-menu-button",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "px-3 d-block mt-2 btn cb-menu-button-new",
                                                    staticStyle: {
                                                      height: "30px",
                                                      "border-radius": "16px",
                                                      margin: "0 auto",
                                                    },
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: _vm.addButton,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        + " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "chatbot.addNewButton"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.selectedItem.formItems,
                                      function (formItem, i) {
                                        return _vm.selectedItem.type === "form"
                                          ? _c(
                                              "div",
                                              {
                                                key: i,
                                                staticClass:
                                                  "my-1 position-relative px-3 input-items cb-hover-item cb-container",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      transform:
                                                        "translate(-20px, 20px)",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "cb-hover-close-btn",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.selectedItem.formItems.splice(
                                                              i,
                                                              1
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "md-icon",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [_vm._v("delete")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    i !== 0
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "cb-hover-up-btn",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.moveUp(
                                                                  i,
                                                                  "formItems"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "md-icon",
                                                              {
                                                                staticClass:
                                                                  "text-info",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "arrow_upward"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    i !==
                                                    _vm.selectedItem.formItems
                                                      .length -
                                                      1
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "cb-hover-down-btn",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.moveDown(
                                                                  i,
                                                                  "formItems"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "md-icon",
                                                              {
                                                                staticClass:
                                                                  "text-info",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "arrow_downward"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "cb-text-item",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: formItem.key,
                                                          expression:
                                                            "formItem.key",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "w-100 bg-white border-0 px-3 d-block mt-2 stepItem",
                                                      staticStyle: {
                                                        height: "50px",
                                                        "border-radius": "16px",
                                                      },
                                                      attrs: {
                                                        placeholder: _vm.$t(
                                                          "chatbot.questionLabel"
                                                        ),
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value: formItem.key,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            formItem,
                                                            "key",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "md-icon",
                                                      {
                                                        staticClass:
                                                          "text-info",
                                                        staticStyle: {
                                                          position: "absolute",
                                                          right: "26px",
                                                          top: "69px",
                                                          "font-size":
                                                            "40px !important",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        help_outline\n                                    "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            formItem.description,
                                                          expression:
                                                            "formItem.description",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "w-100 bg-white border-0 px-3 d-block mt-2 stepItem",
                                                      staticStyle: {
                                                        height: "50px",
                                                        "border-radius": "16px",
                                                        "padding-right":
                                                          "50px !important",
                                                      },
                                                      attrs: {
                                                        placeholder: _vm.$t(
                                                          "chatbot.questionMessage"
                                                        ),
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          formItem.description,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            formItem,
                                                            "description",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("a-divider"),
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c("b-spinner"),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }